import React from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Icon, Popconfirm } from 'antd';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';

import generatePath from '~settings/routing';
import { DragMore } from 'common/components/svgs';

import { DELETE_ARTICLE } from '../../gql';

export default function DragTable({
  refetch = () => {},
  type,
  data = [],
  title = '',
  setData = () => {},
}) {
  const history = useHistory();
  const handleCreateArticle = () => {
    const articlePath = generatePath('newArticleDesign', {
      type,
      index: data.length + 1,
    });
    history.push(articlePath);
  };

  const [deleteArticle] = useMutation(DELETE_ARTICLE, {
    onCompleted: result => {
      if (result?.deleteArticle?.success) {
        refetch();
      }
    },
  });

  const handleDelete = (id, idx) => {
    const tempData = [...data];
    deleteArticle({ variables: { input: { id } } });
    tempData.splice(idx, 1);
    setData([...tempData]);
  };

  const handleDragEnd = result => {
    if (data.length === 1) return;
    const { destination, source } = result;
    const tempData = [...data];
    const temp = tempData[source.index];
    tempData[source.index] = tempData[destination.index];
    tempData[destination.index] = temp;
    setData(tempData);
  };

  return (
    <div
      className="drag-table-wrapper"
      style={{ height: data.length > 0 ? 49 + data.length * 50 + 'px' : 150 }}
    >
      <div className="drag-table-header">
        <span className="drag-title">{title}</span>
        <div className="add-new-btn">
          <Icon type="plus" className="plus-icon" />
          <span className="content" onClick={handleCreateArticle}>
            Add New Article
          </span>
        </div>
      </div>
      <Choose>
        <When condition={data.length === 0}>
          <div className="drag-empty">You currently don’t have any articles for this session.</div>
        </When>
        <Otherwise>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="article" type="group">
              {provided => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  <For of={data} each="item" index="index">
                    <Draggable draggableId={item.id} key={item.id} index={index}>
                      {provided => (
                        <div
                          {...provided.dragHandleProps}
                          {...provided.draggableProps}
                          ref={provided.innerRef}
                          className="table-item"
                        >
                          <div className="table-item-left">
                            <DragMore className="more-icon" />
                            <span className="cursor">{index + 1}</span>
                            <span>{item.title}</span>
                          </div>
                          <Popconfirm
                            title="Are you sure delete this article?"
                            okText="Delete"
                            okType="danger"
                            onConfirm={() => handleDelete(item.id, index)}
                          >
                            <Icon type="delete" className="delete-icon" />
                          </Popconfirm>
                        </div>
                      )}
                    </Draggable>
                  </For>
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Otherwise>
      </Choose>
    </div>
  );
}
